<template>
	<div class="device-account">
		<gc-header header-data="timeoutDevice">
			<template #ops>
				<el-button v-click-blur @click="handleRecordExport">导 出</el-button>
			</template>
		</gc-header>
		<div class="content">
			<div class="filter">
				<gc-advanced-filter
					v-model="params"
					:fields="filterFields"
					@search="handleFilterSearch"
					@reset="handleFilterReset"
				/>
				<gc-column-setting
					:storageKey="`localcolumn-timeout-device-${tenantType}`"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table" v-loading="loading">
				<gc-table
					ref="deviceTable"
					border
					showPage
					:total="total"
					:columns="columnList"
					:table-data="tableData"
					:page-size="pageSize"
					:current-page.sync="currentPage"
					@size-change="handleSizeChange"
					@current-page-change="pageChange"
				></gc-table>
			</div>
		</div>
		<!--  -->
	</div>
</template>

<script>
import { isBlank } from '@/utils/validate'
import { mapActions } from 'vuex'
import { apiGetDeviceList } from '@/apis/account.api'
import { deviceDetailPermissions } from '@/config/const'
import { exportReport } from '@/apis/statisticAnalysis.api'
import { apiGetTenantConfigs } from '@/apis/tenant.api'
import { apiGetDeviceTypeList } from '@/apis/account.api'

export default {
	name: 'deviceAccount',
	data() {
		return {
			dynomicKeys: [],
			searchOptions: {
				deviceTypeId: [],
				deviceStatus: [],
				deviceTypeClassify: [],
				userType: [],
			},
			params: {
				deviceNo: null,
				designNo: null,
				deviceTypeClassify: null,
				deviceTypeIdList: [],
				deviceStatus: null,
				installDate: [],
				userType: null,
				address: null,
			},
			tableData: [],
			total: 0,
			currentPage: 1,
			pageSize: 20,
			showDialog: false,
			title: '设备新增',
			dialogParams: {},
			dialogType: 'add',
			dialogChangeType: 0,
			pageParams: {},
			currentDeviceId: null,
			loading: false,
			dialogLoading: false,
			showUasyncBtn: true,
			columns: [],
		}
	},
	activated() {
		if (this.$route.params?.update) {
			this.params.deviceTypeClassify = this.$route.params.deviceTypeClassify
			this.params.deviceTypeIdList = []
			this.getDeviceList(1)
		}
	},
	created() {
		this.getTenantConfigs()
		if (this.$route.params?.deviceTypeClassify) {
			this.params.deviceTypeClassify = this.$route.params.deviceTypeClassify
		}
		this.getDeviceList(1)
		this.searchOptions.deviceStatus = this.$store.getters?.dataList?.deviceStatus || []
		this.searchOptions.userType = this.$store.getters?.dataList?.userType || []
		if (this.tenantType !== '1') {
			this.$set(
				this.searchOptions,
				'deviceTypeClassify',
				this.$store.getters.dataList.deviceTypeClassify.map(item => {
					return {
						label: item.name,
						value: item.defaultValue,
					}
				}),
			)
		}
	},
	methods: {
		...mapActions({
			getFirstCategory: 'common/getFirstCategory',
			judgeNeedPickOrg: 'user/judgeNeedPickOrg',
			getDeviceTypes: 'common/getAllDeviceTypeList',
		}),
		async queryDeviceTypeList() {
			apiGetDeviceTypeList({ tenantId: this.tenantId, deviceTypeClassify: this.params.deviceTypeClassify }).then(
				res => {
					let list = res.records || []
					let val = list.map(item => {
						return {
							value: item.deviceTypeId,
							label: item.deviceTypeName,
						}
					})
					this.searchOptions.deviceTypeId = val
				},
			)
		},
		handleRecordExport() {
			if (!this.tableData.length) {
				return this.$message.warning('暂无表格数据')
			}
			const params = this.getRequestParams()
			if (!params) return
			this.$toast('下载中，请稍后...')
			const data = {
				method: 'post',
				url: '/monitor/report/device-ledger/export/excel',
				fileName: '超使用年限设备列表.xlsx',
				data: { ...params, overdueFlag: 1, tenantType: this.tenantType },
			}
			exportReport(data, 'excel', '', this.$toast)
		},
		getTenantConfigs() {
			apiGetTenantConfigs({ tenantId: this.tenantId }).then(res => {
				const list = res.dataList || []
				list.forEach(item => {
					if (item.key === 'enable_uasync') {
						this.showUasyncBtn = item.value === 'true'
					}
				})
			})
		},
		checkDetail(row) {
			this.$router.push({
				name: 'deviceDetail', // timeoutDeviceDetail
				query: {
					deviceId: row.deviceId,
					deviceType: row.deviceTypeId,
					source: 'timeoutDevice',
				},
			})
		},
		getRequestParams() {
			const params = {}
			for (const key in this.params) {
				const value = this.params[key]
				if (!isBlank(value)) {
					if (key === 'installDate' && value.length) {
						params.installStartDate = this.dayjs(value[0]).format('YYYY-MM-DD')
						params.installEndDate = this.dayjs(value[1]).format('YYYY-MM-DD')
					} else {
						params[key] = value
					}
				}
			}
			delete params.installDate
			if (params.address && params.address.length < 2) return this.$message.warning('安装地址不可以少于2个字符')
			return params
		},
		handleFilterSearch() {
			this.getDeviceList(1)
		},
		handleFilterReset() {
			this.getDeviceList(1)
		},
		handleSizeChange(size) {
			this.pageSize = size
			this.getDeviceList(1)
		},
		getDeviceList(current) {
			const data = this.getRequestParams()
			if (!data) return
			data.current = current
			data.size = this.pageSize
			this.loading = true
			apiGetDeviceList({ ...data, overdueFlag: 1, tenantType: this.tenantType })
				.then(res => {
					this.tableData = res.records || []
					this.total = res.total
					this.currentPage = res.current
				})
				.catch(() => {})
				.finally(() => {
					this.loading = false
				})
		},
		pageChange(current) {
			this.getDeviceList(current)
		},
		reset() {
			for (var key in this.params) {
				this.params[key] = null
			}
			this.getDeviceList(1)
		},
		getDynomicKeys(list) {
			this.dynomicKeys = list
		},
	},
	watch: {
		'params.deviceTypeClassify': {
			handler(newVal) {
				if (newVal) {
					this.params.deviceTypeIdList = []
				}
				this.queryDeviceTypeList()
			},
			immediate: true,
		},

		tenantType: {
			handler() {
				this.columns = [
					{
						key: 'deviceNo',
						name: '设备通讯编号',
						tooltip: true,
						fixed: 'left',
						dragDisable: true,
						disabledSelect: true,
					},
					{
						key: 'designNo',
						name: '外观编号',
						tooltip: true,
					},
					{
						key: 'firstCategoryName',
						name: '设备大类',
						tooltip: true,
						hidden: this.tenantType === '1',
					},
					{
						key: 'deviceTypeName',
						name: '设备类型',
						tooltip: true,
						hidden: this.tenantType === '1',
					},
					{
						key: 'userTypeName',
						name: '客户类型',
						tooltip: true,
						hidden: this.tenantType === '0',
					},
					{
						key: 'userNo',
						name: '用户号',
						tooltip: true,
					},
					{
						key: 'username',
						name: '客户/站点名称',
						tooltip: true,
					},
					{
						key: 'userPhone',
						name: '手机号码',
						tooltip: true,
					},
					{
						key: 'userPhone2',
						name: '联系电话',
						tooltip: true,
					},
					{
						key: 'addressName',
						name: '安装地址',
						tooltip: true,
						width: 200,
					},
					{
						key: 'firstInstallDate',
						name: '安装时间',
					},
					{
						key: 'useYear',
						name: '设备寿命',
						tooltip: true,
						render: (h, row) => {
							const { useYear } = row
							return h('span', {}, isBlank(useYear) ? '--' : useYear + '年')
						},
					},
					{
						key: 'overdueDate',
						name: '到期时间',
					},
					{
						key: 'oprate',
						name: '操作',
						width: '250px',
						fixed: 'right',
						render: (h, row) => {
							// 根据安装状态进行动态变化
							// 如果状态是异常则展示或者没有任何操作权限  /
							if (isBlank(row.deviceStatus)) {
								return h('span', { style: { color: '#CCCCCC' } }, '/')
							}
							let style = {
								'font-size': '14px',
								'font-family': 'SourceHanSansCN-Regular, SourceHanSansCN',
								'font-weight': '400',
								color: '#4A69FF',
								'line-height': '21px',
								'margin-right': '20px',
								cursor: 'pointer',
							}
							return h('div', {}, [
								...[
									this.$has(deviceDetailPermissions)
										? [
												h(
													'span',
													{
														on: {
															click: () => this.checkDetail(row),
														},
														style,
													},
													'查看详情',
												),
										  ]
										: [],
								],
							])
						},
					},
				].filter(m => !m.hidden)
			},
			immediate: true,
		},
	},
	computed: {
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},
		isOnlineOptions() {
			return this.$store.getters.dataList.isOnline || []
		},
		isAlarmOptions() {
			return this.$store.getters.dataList.isAlarm || []
		},
		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},
		filterFields() {
			return [
				{ prop: 'deviceNo', label: '设备通讯编号', type: 'input' },
				{ prop: 'designNo', label: '外观编号', type: 'input' },
				{
					prop: 'userType',
					label: '客户类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.userType,
						needAllForSearch: true,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
					},
					hidden: this.tenantType !== '1',
				},
				{
					prop: 'deviceTypeClassify',
					label: '设备大类',
					type: 'select',
					props: {
						searchOption: this.searchOptions.deviceTypeClassify,
						filterable: true,
						needAllForSearch: true,
					},
					hidden: this.tenantType === '1',
				},
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.deviceTypeId,
						filterable: true,
						needAllForSearch: true,
						multiple: true,
					},
					hidden: this.tenantType === '1',
				},
				{ prop: 'address', label: '安装地址', type: 'input' },
			].filter(item => !item.hidden)
		},
		columnList() {
			return this.columns.filter(o => o.selected)
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			let needRefresh = vm.$store.getters.needRefresh
			if (needRefresh) {
				vm.reset()
				vm.$store.dispatch('account/changeStatus', false)
			}
		})
	},
}
</script>
<style lang="scss" scoped>
.device-account {
	@include base-button(80px);
	display: flex;
	flex-direction: column;
	height: 100%;
	.content {
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		flex: 1;
		height: 0;
		padding: 0 12px;
		.filter {
			display: flex;
			flex-wrap: wrap;
			padding: 12px 0;
		}
		.table {
			flex: 1;
			height: 0;
		}
	}
}
</style>
